import React, { Component } from 'react';
import { connect } from 'react-redux'
import ConfiguracionSesionEditar from './ConfiguracionSesionEditar';

////Importación de actions.
import {
    getScreenData,
    resetState,
    guardarConfiguracion,
    checkboxChangeState,
    configurationTypeChange,
    radioButtonChange,
    textChangeState,
    plataformaValueChange,
    radioButtonChangeContrasenia,
    hidePopUp,
    setRedirectOk
} from '../actions/ConfiguracionSesionEditar';

const mapStateToProps = (state) => {
    return {
        data: state.configuracionSesionEditar,
        concierge: state.concierge
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        resetState: () => {
            dispatch(resetState());
        },
        setRedirectOk: () => {
            dispatch(setRedirectOk());
        },
        guardarConfiguracion: (config) => {
            dispatch(guardarConfiguracion(config));
        },
        checkboxChangeState: (obj) => {
            dispatch(checkboxChangeState(obj));
        },
        configurationTypeChange: (oldConfigurationType) => {
            dispatch(configurationTypeChange(oldConfigurationType));
        },
        radioButtonChange: (obj) => {
            dispatch(radioButtonChange(obj));
        },
        textChangeState: (obj) => {
            dispatch(textChangeState(obj));
        },
        plataformaValueChange: (obj) => {
            dispatch(plataformaValueChange(obj));
        },
        radioButtonChangeContrasenia: (obj) => {
            dispatch(radioButtonChangeContrasenia(obj));
        },
        hidePopUp: () => {
            dispatch(hidePopUp());
        }
    }
}

const ConfiguracionSesionEditarContainer = connect(mapStateToProps, mapDispatchToProps)(ConfiguracionSesionEditar);

export default ConfiguracionSesionEditarContainer;